import { generateVoicemail as generateVoicemailAPI } from '../api/flows';

export interface GenerateVoicemailResult {
  voicemail?: string;
  queued: boolean;
  requestId?: string;
}

/**
 * Generate voicemail content via the Remi voicemail-generator API.
 *
 * This intentionally does NOT persist the voicemail back to the flow — a
 * partial PUT (with only voicemail_content) caused the backend to null out
 * other fields. Persistence is the caller's responsibility:
 *   - On flow create: pass voicemail_content into the createFlow payload.
 *   - On regenerate from EditFlowModal: state is updated via onRegenerated;
 *     the eventual Save sends the full flow payload.
 *
 * `flowId` is unused but kept in the signature to avoid touching every caller.
 */
export const generateVoicemail = async (
  _flowId: string,
  description: string
): Promise<GenerateVoicemailResult> => {
  try {
    const response = await generateVoicemailAPI(description);

    if (response.voicemail) {
      return {
        voicemail: response.voicemail,
        queued: false,
        requestId: response.request_id,
      };
    }

    return {
      queued: Boolean(response.queued),
      requestId: response.request_id,
    };
  } catch (error) {
    console.error('Error in voicemail generation:', error);
    throw error;
  }
};
